import colorByAgentCategoryMixin from './colorByAgentCategoryMixin'

export const colorByAgentCategory = colorByAgentCategoryMixin
